import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { ComponentsResponse, SingleComponentResponse } from './types.tsx';

export const MAX_RESULTS = 5;

export const getComponentsEndpointUrlOld = (projectKeyOrId: string): string =>
	`/rest/api/2/project/${projectKeyOrId}/component`;

export const getComponentsEndpointUrl = (projectKeyOrId: string): string =>
	`/rest/api/3/project/${projectKeyOrId}/component`;

export const getComponentsUrlParams = (filter: string, ignore: string[]): string =>
	`startAt=0&maxResults=${MAX_RESULTS + ignore.length}&query=${encodeURIComponent(filter)}`;

export const getComponentsRetrieveUrlOld = (
	projectKeyOrId: string,
	filter: string,
	ignore: string[],
): string =>
	`${getComponentsEndpointUrlOld(projectKeyOrId)}?${getComponentsUrlParams(filter, ignore)}`;

export const getComponentsRetrieveUrl = (
	projectKeyOrId: string,
	filter: string,
	ignore: string[],
): string =>
	`${getComponentsEndpointUrl(projectKeyOrId)}?${getComponentsUrlParams(filter, ignore)}`;

export const getComponentsOld = (
	projectKeyOrId: string,
	filter: string,
	ignore: string[],
): Promise<ComponentsResponse> =>
	fetchJson(getComponentsRetrieveUrlOld(projectKeyOrId, filter, ignore));

export const getComponents = (
	projectKeyOrId: string,
	filter: string,
	ignore: string[],
): Promise<ComponentsResponse> =>
	fetchJson(getComponentsRetrieveUrl(projectKeyOrId, filter, ignore));

export const getComponentEndpointUrl = (componentId: string): string =>
	`/rest/api/3/component/${componentId}`;

export const getComponent = (componentId: string): Promise<SingleComponentResponse> =>
	fetchJson(getComponentEndpointUrl(componentId));
